import { Box } from "@mui/material";
import RenderInputField from "components/ReusableComponents/RenderInputField/RenderInputField";
import SearchInputFieldWithDebounce from "components/PimDashboard/CommonComponents/SearchInputFieldWithDebounce/SearchInputFieldWithDebounce";
import { datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { soMasterCacheKeyByColumn } from "../shared/bqMasterDropdownCache";
import { soMasterFetches } from "./data";

export const fieldWidth = (column) =>
	column?.data_type === datatypes.LONGTEXT.key ? "100%" : "32%";

const SoColumnField = ({ column, data, setData, readOnly = false, error, width, dense = false }) => {
	const isLocked = readOnly || !!column.disabled;
	const disabledColumn = isLocked ? { ...column, input_type: inputTypes.AUTO_GENERATE.key, editable: false } : column;
	const wrapSx = { width: width || fieldWidth(column), mb: dense ? 0 : 1.5 };

	if (column.use_bq_search) {
		return (
			<Box sx={wrapSx}>
				<SearchInputFieldWithDebounce
					column={disabledColumn}
					data={data}
					setData={setData}
					fetchData={soMasterFetches[column.key]}
					selectOptKeyName={selectOptionsKeyName}
					storeValueAs={
						column.key === "owner_site_code" || column.key === "item_code" ? "object" : "key"
					}
					disabled={isLocked}
					width="100%"
					error={error}
					cacheKey={soMasterCacheKeyByColumn[column.key] || `bq_master_${column.key}`}
					labelSx={{ p: 1 }}
				/>
			</Box>
		);
	}

	return (
		<Box sx={wrapSx}>
			<RenderInputField
				column={disabledColumn}
				data={data}
				setData={setData}
				selectOptObjName={selectOptionsKeyName}
				width="100%"
				error={error}
			/>
		</Box>
	);
};

export default SoColumnField;
